<template>
	<div class="vimeo-slide">
		<video ref="video" @timeupdate="onTimeUpdate" playsinline :loop="true" muted :poster="thumbnail" autoplay>
			<source type="video/mp4" :src="value" />
		</video>

		<div v-if="$slots.overlay" class="slider__overlay-wrapper">
			<slot name="overlay" />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: String,
		thumbnail: String,
		loop: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			videoElement: null,
			paused: null,
			ready: false,
			player: null,
		}
	},

	computed: {
		videoId() {
			const rg = /^https:+[/]+[/]+vimeo.com+[/]*([0-9]+)*/
			let match = rg.exec(this.value)
			return match[1]
		},
	},
	methods: {
		onPlay() {
			let duration = this.$refs.video.duration
			setTimeout(() => {
				this.$emit('ended')
			}, duration * 1000 - 750)
		},
		play() {
			this.ready = true
			this.videoIsPlaying = true
			this.videoElement.play()
		},
		pause() {
			this.videoElement.pause()
		},
		update() {
			this.videoElement = event.target
			this.paused = event.target.paused
		},
		onTimeUpdate(e) {
			this.$emit('timeupdate', { total: e.target.duration * 1000, elapsed: e.target.currentTime * 1000 })
		},
	},
	mounted() {},

	components: {},
}
</script>

<style lang="scss">
// position: relative;
// z-index: get-layer('vimeo-slide');
.vimeo-slide {
	video {
		position: absolute;
		top: 0;
		left: 0;
		height: inherit;
		width: 100vw;
		object-fit: cover;
		object-position: center;
	}
}
</style>
